module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062847355_Contents#r_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("In a shrine of ancients past")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("When the dark has stolen the throne,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("The Goddess holds the end of times")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("And there she waits alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("And when she fails its heart will beat")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("And consume the kingdom bright,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("For no soul lives to tell the tale")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("Of a star to shine the light.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("—“The Goddess’s Legacy,”")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("The Cantos of Light")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc8b3a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062847355_Epigraph.vue
// module id = 63
// module chunks = 0